module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Permissions")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), (_vm.$root.permissions['create permission']) ? _c('div', {
    staticClass: "portlet box blue-hoki margin-top-20"
  }, [_c('div', {
    staticClass: "portlet-title bg-blue-chambray",
    on: {
      "click": function($event) {
        _vm.toggleCreatePermissionPanel()
      }
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('a', {
    class: {
      'expand': !_vm.createCollapse, 'collapse': _vm.createCollapse
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.createCollapse),
      expression: "!createCollapse"
    }],
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createPermission()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.createErrorMessage.length),
      expression: "createErrorMessage.length"
    }],
    ref: "createErrorMessage",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearCreateError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.createErrorMessage))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPermission.name),
      expression: "newPermission.name"
    }],
    ref: "newPermissionName",
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newPermission.name.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_name"
    },
    domProps: {
      "value": (_vm.newPermission.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPermission, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_name"
    }
  }, [_vm._v("Name")])]), _vm._v(" "), _c('button', {
    staticClass: "btn blue pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.permissions.length) ? _c('div', {
    staticClass: "margin-top-20"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_c('div', {
    staticClass: "portlet-title",
    on: {
      "click": function($event) {
        _vm.toggleSearchPanel()
      }
    }
  }, [_vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('a', {
    class: {
      'expand': !_vm.searchCollapse, 'collapse': _vm.searchCollapse
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.searchCollapse),
      expression: "!searchCollapse"
    }],
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.advancedSearch()
      }
    }
  }, [_c('div', {
    staticClass: "form-body row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.searchError.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearSearchError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.searchError))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "search",
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.searchTerm.length
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "search_options_search"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("Search by name.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions right margin-top-20"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetSearch()
      }
    }
  }, [_vm._v(" Reset Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")])])])])])]) : _vm._e(), _vm._v(" "), _c('loading-screen', {
    attrs: {
      "show": _vm.loading,
      "color": '#2C3E50',
      "display": 'inline'
    }
  }), _vm._v(" "), (_vm.permissions.length && !_vm.loading && !_vm.filteredResults.length) ? _c('div', [_c('div', {
    staticClass: "portlet light portlet-fit bordered margin-top-20"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.permissions.length) ? _c('div', {
    staticClass: "clearfix margin-bottom-10"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateSortByOrder
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSort by\n\t\t\t\t\t\t\t\t"), _c('span', [(_vm.sortBy.order === 'ASC') ? _c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  }) : _vm._e(), _vm._v(" "), (_vm.sortBy.order === 'DESC') ? _c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  }) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "ASC"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "DESC"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })])], 1)], 1), _vm._v(" "), _c('page-results', {
    staticClass: "pull-right",
    attrs: {
      "totalResults": _vm.permissions.length,
      "activePage": _vm.activePage
    },
    on: {
      "pageResults": _vm.pageResultsUpdate
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-element-list"
  }, [_c('div', {
    staticClass: "mt-list-container list-news"
  }, [_c('ul', _vm._l((_vm.currentActivePageItems), function(permission) {
    return _c('li', {
      key: permission.id,
      staticClass: "mt-list-item actions-at-left margin-top-15",
      class: {
        'animated': _vm.animated === ("permission-" + (permission.id))
      },
      attrs: {
        "id": 'permission-' + permission.id
      }
    }, [_c('div', {
      staticClass: "list-item-actions"
    }, [(_vm.$root.permissions['update permission']) ? _c('el-tooltip', {
      attrs: {
        "content": "Edit",
        "effect": "light",
        "placement": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.editPermission(permission)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['list permission'] && !_vm.$root.permissions['update permission']) ? _c('el-tooltip', {
      attrs: {
        "content": "View",
        "effect": "light",
        "placement": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.editPermission(permission)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['delete permission']) ? _c('el-tooltip', {
      attrs: {
        "content": "Delete",
        "effect": "light",
        "placement": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.showDeleteModal(permission)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "list-datetime bold uppercase font-red"
    }, [_c('span', [_vm._v(_vm._s(permission.name))])])])
  }))]), _vm._v(" "), (_vm.permissions.length && _vm.numPages > 1) ? _c('div', {
    staticClass: "clearfix"
  }, [_c('pagination', {
    attrs: {
      "passedPage": _vm.activePage,
      "numPages": _vm.numPages
    },
    on: {
      "activePageChange": _vm.activePageUpdate
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listErrorMessage.length),
      expression: "listErrorMessage.length"
    }],
    ref: "listErrorMessage",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearListError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.listErrorMessage))])])])])]) : _vm._e(), _vm._v(" "), (_vm.permissions.length && !_vm.loading && _vm.filteredResults.length) ? _c('div', [_c('div', {
    staticClass: "portlet light portlet-fit bordered margin-top-20"
  }, [_vm._m(4, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.filteredResults.length) ? _c('div', {
    staticClass: "clearfix margin-bottom-10"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateSortByOrder
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSort by\n\t\t\t\t\t\t\t\t"), _c('span', [(_vm.sortBy.order === 'ASC') ? _c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  }) : _vm._e(), _vm._v(" "), (_vm.sortBy.order === 'DESC') ? _c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  }) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "ASC"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "DESC"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })])], 1)], 1), _vm._v(" "), _c('page-results', {
    staticClass: "pull-right",
    attrs: {
      "totalResults": _vm.filteredResults.length,
      "activePage": _vm.searchActivePage
    },
    on: {
      "pageResults": _vm.pageResultsUpdate
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-element-list"
  }, [_c('div', {
    staticClass: "mt-list-container list-news"
  }, [_c('ul', _vm._l((_vm.currentActiveSearchPageItems), function(permission) {
    return _c('li', {
      key: permission.id,
      staticClass: "mt-list-item actions-at-left margin-top-15",
      class: {
        'animated': _vm.animated === ("permission-" + (permission.id))
      },
      attrs: {
        "id": 'permission-' + permission.id
      }
    }, [_c('div', {
      staticClass: "list-item-actions"
    }, [(_vm.$root.permissions['update permission']) ? _c('el-tooltip', {
      attrs: {
        "content": "Edit",
        "effect": "light",
        "placement": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.editPermission(permission)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['list permission'] && !_vm.$root.permissions['update permission']) ? _c('el-tooltip', {
      attrs: {
        "content": "View",
        "effect": "light",
        "placement": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.editPermission(permission)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['delete permission']) ? _c('el-tooltip', {
      attrs: {
        "content": "Delete",
        "effect": "light",
        "placement": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.showDeleteModal(permission)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "list-datetime bold uppercase font-red"
    }, [_c('span', [_vm._v(_vm._s(permission.name))])])])
  }))]), _vm._v(" "), (_vm.filteredResults.length && _vm.searchNumPages > 1) ? _c('div', {
    staticClass: "clearfix"
  }, [_c('pagination', {
    attrs: {
      "passedPage": _vm.searchActivePage,
      "numPages": _vm.searchNumPages
    },
    on: {
      "activePageChange": _vm.activeSearchPageUpdate
    }
  })], 1) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (!_vm.permissions.length && !_vm.loading) ? _c('div', [_c('no-results', {
    attrs: {
      "show": !_vm.permissions.length,
      "type": 'permissions'
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.showEditPermissionModal,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeEditPermissionModal
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeEditPermissionModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Edit Permission")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editErrorMessage.length),
      expression: "editErrorMessage.length"
    }],
    ref: "editErrorMessage",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearEditError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.editErrorMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionToEdit.name),
      expression: "permissionToEdit.name"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.permissionToEdit.name.length
    },
    attrs: {
      "disabled": _vm.$root.permissions['list permission'] && !_vm.$root.permissions['update permission'],
      "type": "text",
      "id": "form_control_edited_name"
    },
    domProps: {
      "value": (_vm.permissionToEdit.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.permissionToEdit, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_edited_name"
    }
  }, [_vm._v("Name")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(_vm.$root.permissions['list permission'] && !_vm.$root.permissions['update permission']) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeEditPermissionModal()
      }
    }
  }, [_vm._v("\n\t\t\t\tClose\n\t\t\t")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updatePermission()
      }
    }
  }, [_vm._v("\n\t\t\t\tSave\n\t\t\t")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.showDeletePermissionModal,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeDeletePermissionModal
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeDeletePermissionModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Delete Permission")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteErrorMessage.length),
      expression: "deleteErrorMessage.length"
    }],
    ref: "deleteErrorMessage",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearDeleteError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.deleteErrorMessage))])]), _vm._v(" "), _c('p', [_vm._v("Are you sure you want to delete this permission?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deletePermission()
      }
    }
  }, [_vm._v("Delete")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note note-info"
  }, [_c('p', [_vm._v("Create and manage user permissions.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v("\n\t\t\t\t\tCreate New Permission\n\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n\t\t\t\t\t\tSearch Panel\n\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "menu-image-main"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/client_logo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "caption-subject font-green bold uppercase"
  }, [_vm._v("Permissions")]), _vm._v(" "), _c('div', {
    staticClass: "caption-desc font-grey-cascade"
  }, [_vm._v("Click on the edit button to edit a permission.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "menu-image-main"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/client_logo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "caption-subject font-green bold uppercase"
  }, [_vm._v("Search Results")]), _vm._v(" "), _c('div', {
    staticClass: "caption-desc font-grey-cascade"
  }, [_vm._v("Click on the edit button to edit a permission.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f22e1b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/AdminManager/Permissions.vue
// module id = 720
// module chunks = 0